@if ({
  productPrice: productPriceItem$ | async,
  product: product$ | async
  }; as type) {
  <ng-template [cxOutlet]="outlets.PRICE"
    [cxOutletContext]="{ product: type.productPrice }">
    @if (isUserLoggedIn$ | async) {
      @if (type.productPrice?.listPrice) {
        @if (type.productPrice.listPrice.value > 0) {
          @if (displayCustomerPrices$ | async) {
            @if (type.productPrice?.customerPrice?.value > 0) {
              <div class="price" aria-label="Product price">
                <span [ngClass]="{ 'discounted-price' : type.productPrice?.customerPrice?.value < type.productPrice?.listPrice?.value }">
                  {{ type.productPrice?.customerPrice?.formattedValue }}
                </span>
                @if (type.productPrice?.customerPrice?.value < type.productPrice?.listPrice?.value) {
                  <span
                    class="crossed-price-wrapper">
                    <span
                    class="crossed-price-text">{{ 'eProductDetails.crossedPrice.label' | cxTranslate }}</span>
                    <span class="crossed-price">{{ type.productPrice?.listPrice?.formattedValue }}</span>
                  </span>
                }
              </div>
            } @else {
              @if (type.productPrice?.listPrice) {
                <div class="price" aria-label="Product price">
                  {{ type.productPrice?.listPrice.formattedValue }}
                </div>
              }
            }
          } @else {
            @if (type.productPrice?.listPrice) {
              <div class="price" aria-label="Product price">
                {{ type.productPrice?.listPrice.formattedValue }}
              </div>
            }
          }
        } @else {
          <div aria-label="No price" class="no-price">
            <span class="u-font-bold">
              {{ 'noPriceToDisplayForProduct' |  cxTranslate }}
            </span>
          </div>
        }
      }
    } @else {
      @if (type.productPrice?.listPrice) {
        @if (type.productPrice?.listPrice.value > 0) {
          <div class="price" aria-label="Product price">
            {{ type.productPrice?.listPrice.formattedValue }}
          </div>
        } @else {
          <div aria-label="No price" class="no-price">
            <span class="u-font-bold">
              {{ 'noPriceToDisplayForProduct' |  cxTranslate }}
            </span>
          </div>
        }
      }
    }
  </ng-template>
  <div class="action-box ">
    <app-efa-add-to-cart class=""
      [isCalledFromDPD]="true"
      [showQuantity]="false"
      [product]="type.product"
      [showQuantityHint]="false"
      [priceAvailable]="type.productPrice?.listPrice && type.productPrice?.listPrice.value > 0"
      [useDefaultAddToCart]="false"
      [listPricePerUnit]="type.productPrice?.listPrice"
      [customerPricePerUnit]="type.productPrice?.customerPrice">
    </app-efa-add-to-cart>
    <app-efa-cart-item-add-to-wish-list
      class=""
      [product]="type.product"
      [orderInfoRefId]="0"
      [IsAddedFromSearchPage]="true">
    </app-efa-cart-item-add-to-wish-list>
  </div>
  <ng-template [cxOutletContext]="{ product: type }"
    [cxOutlet]="outlets.SUMMARY">
    <!-- <p [innerHTML]="type.product?.summary" class="summary"></p> -->
    <div class="summary-box"
      [ngStyle]="{'display': !type.product?.summary ? 'none' : 'block' }">
      <p [ngClass]="{'summary-title' : !!SummaryTitle}">{{SummaryTitle }}</p>
      <p class="summary-value">{{summaryValue}}</p>
    </div>
    @if (type.productPrice?.deliveryTime) {
      <div class="delivery-time-box" aria-label="Product delivery time">
        <p [ngClass]="{'delivery-time-title' : !!type.productPrice?.deliveryTime}">{{ 'eProductDetails.deliveryTimeLabel' | cxTranslate }}&nbsp;</p>
        <p class="delivery-time-value" ><span>{{ 'eProductDetails.deliveryTimeText' | cxTranslate }}</span> {{type.productPrice?.deliveryTime}}&nbsp;{{ 'eProductDetails.deliveryTimeValue' | cxTranslate }}</p>
      </div>
    }
  </ng-template>
  <app-efa-product-details-tab>
  </app-efa-product-details-tab>
}
